import { useQueryClient } from '@tanstack/vue-query';

/**
 *
 */
export function useStartFreshFlow() {
    const cartStore = useCartStore();
    const route = useRoute();
    const queryClient = useQueryClient();

    /**
     *
     */
    function startFreshFlow(productConfig: ProductConfig) {
        // Create a new, iterated productId for the new product
        // e.g. if product "2" of same product key already exists, it returns "3"
        // If no products exist, it returns "1"
        const productId = cartStore.getFreshProductId(productConfig);

        const stepRoute = getStepRoute(productConfig.steps.find(s => s.routeName.includes(route.query.step as string)), productId, 'booking')
            ?? getFirstFlowRoute(productConfig.steps, productId, 'booking');

        // Clear offer configs. Needs to be set freshly for new product
        queryClient.removeQueries({ queryKey: ['offer-requirements'] });
        queryClient.removeQueries({ queryKey: ['reduction-cards'] });

        // Proceed to that step of the flow for that product, with the new productId in the route, and keeping any existing query params (e.g. for presets)
        return navigateTo({
            ...stepRoute,
            query: route?.query,
        }, { replace: true });
    }

    return {
        startFreshFlow,
    };
}
